var ServicePartnerMap = (function () {
    var resourcesPath = "https://static.delti.com/static/common_files/images/spartner/";
    var leafletIcon1 = resourcesPath + "mp_pin.png";
    var leafletIcon2 = resourcesPath + "mp_pin-active.png";

    var servicePartners = [];
    var markers = [];

    var map = [];
    var mapZoom = 40;

    var infoWindow;

    var mapStyles = [
        {
            stylers: [
                {hue: "#00ffe6"},
                {saturation: -20}
            ]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {lightness: 100},
                {visibility: "simplified"}
            ]
        }, {
            featureType: "road",
            elementType: "labels",
            stylers: [
                {visibility: "off"}
            ]
        }
    ];

    function getPolygon() {
        var polygonCoords = [];

        for (var i = 0; i < servicePartners.length; i++) {
            var place = servicePartners[i];
            polygonCoords.push([place.lat, place.long]);
        }

        return L.polygon(polygonCoords);
    }

    function drawLeafletMap() {

        if (!$('#map-canvas0').length && !$('#map-canvas').length) {
            return;
        }

        var polygon = getPolygon();

        if ($('#map-canvas').length && $('#map-canvas').is(":visible")) {
            if (map && map._containerId) {
                map.off();
                map.remove();
            } else {
                map = null;
            }
            map = L.map('map-canvas', {
                zoomControl: false
            }).fitBounds(polygon.getBounds());

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            map.addControl(L.control.zoom({position: 'bottomleft'}));

            for (var i = 0; i < servicePartners.length; i++) {
                var place = servicePartners[i];
                place.index = i;

                L.marker([place.lat, place.long], {
                    title: place.company,
                    icon: L.icon({iconUrl: leafletIcon1}),
                    options: {
                        placeId: place.id
                    }
                })
                    .bindPopup(buildInfoString(place, true))
                    .addTo(map)
                    .on('click', function (ev) {
                        scrollToServicePartner(ev.target.options.options.placeId);
                    })
                    .on('mouseover', function (ev) {
                        ev.target.setIcon(L.icon({iconUrl: leafletIcon2}));
                    })
                    .on('mouseout', function (ev) {
                        ev.target.setIcon(L.icon({iconUrl: leafletIcon1}));
                    });
            }
        }else {
            for (var i = 0; i < servicePartners.length; i++) {

                if (map[i] && map[i]._containerId) {
                    map[i].off();
                    map[i].remove();
                } else {
                    map[i] = null;
                }

                map[i] = L.map('map-canvas'+ i , {
                    zoomControl: false,
                    zoom: 80,
                    zoomSnap: 1,
                    zoomDelta: 1
                }).fitBounds(polygon.getBounds());

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(map[i]);
                var place = servicePartners[i];
                place.index = i;

                L.marker([place.lat, place.long], {
                    title: place.company,
                    icon: L.icon({iconUrl: leafletIcon1}),
                    options: {
                        placeId: place.id
                    }
                })
                    .bindPopup(buildInfoString(place, true))
                    .addTo(map[i])
                    .on('mouseover', function (ev) {
                        ev.target.setIcon(L.icon({iconUrl: leafletIcon2}));
                    })
                    .on('mouseout', function (ev) {
                        ev.target.setIcon(L.icon({iconUrl: leafletIcon1}));
                    });
            }
        }
        $(window).on('resize', function () {
            drawLeafletMap();
        });

        $('#map-canvas')[0].scrollIntoView();
    }

    function buildInfoString(place, disableScroll) {
        var infoString = $.tmpl($('#tmpl-info'), place).html();
        if (!disableScroll) {
            scrollToServicePartner(place.id);
        }
        return infoString;
    }

    function scrollToServicePartner(markerId) {
        var allPartnerCompanyNames = document.getElementsByClassName("hidden-div-id-for-scrolling");
        var results = [];
        for (var k = 0; k < allPartnerCompanyNames.length; k++) {
            allPartnerCompanyNames[k].parentNode.style.backgroundColor = '';

            if (allPartnerCompanyNames[k].innerText === markerId) {
                allPartnerCompanyNames[k].parentNode.style.backgroundColor = 'rgba(70, 120, 170, 0.1)';
                results.push(allPartnerCompanyNames[k]);
            }
        }

        if (results.length > 0) {
            var childNode = results[0].parentNode;
            var selectedElementTop = childNode.offsetTop;
            var servicePartnerListContainer = $('.sp_list').first();
            var servicePartnerListContainerTop = servicePartnerListContainer.position().top;
            servicePartnerListContainer.animate({scrollTop: selectedElementTop - servicePartnerListContainerTop}, 1000);
        }
    }

    function initialize() {
        markers = [];
        if (typeof servicePartners === undefined || !servicePartners.length) {
            return;
        }

        if (ACC.servicePartnersEngine === "leaflet") {
            drawLeafletMap();
            return;
        }

        $("#colorbox").on({
            mouseover: function () {
                var details = $(this).find(".partner-index-btn").first();
                var index = details.data('index');
                var marker = markers[index];

                marker.setIcon(leafletIcon2);
            },
            mouseout: function () {
                var details = $(this).find(".partner-index-btn").first();
                var index = details.data('index');
                var marker = markers[index];

                marker.setIcon(leafletIcon1);
            }
        }, '.partner-result');
    }

    return {
        initialize: initialize,

        getServicePartners: function () {
            return servicePartners;
        },

        setMapZoom: function (zoom) {
            if (typeof zoom !== "number") {
                console.error("Number type required");
            }

            mapZoom = zoom;
        },

        clearServicePartners: function () {
            servicePartners = [];
        }
    };
})();

var ServicePartnerAddOn = (function (servicePartnerMap) {
    var searchResultsContainer;
    var openInPopup = false;
    var preselectedCityOrZipCode = false;
    var redirectAfterSelectedServicePartner = true;
    var onConfirmServicePartner;
    var onClosePopup;

    function closePopup() {
        if (openInPopup && onClosePopup) {
            onClosePopup();
        }
    }

    function showLoadingGif() {
        var loadingGifBackground = $("<div>").prop("id", "service-partner-loading-gif-background");
        var loadingGifContainer = $("<div>").prop("id", "service-partner-loading-gif-container");
        var loadingGifBox = $("<div>").prop("id", "service-partner-loading-gif-box");
        var loadingGif = $("<div>").prop("id", "service-partner-loading-gif");
        $("body").prepend(loadingGifContainer.append(loadingGifBox.append(loadingGif)))
            .prepend(loadingGifBackground);
        loadingGifBox.slideDown(600);
    }

    function hideLoadingGif() {
        $("#service-partner-loading-gif-box").slideUp(600, function () {
            $("#service-partner-loading-gif-container").remove();
            $("#service-partner-loading-gif-background").remove();
        });
    }

    function updateServicePartnerAddComponentIfPresent(company) {
        // update selected service partner for "servicePartnerAddComponent" if present
        var addPartnerComponent = $(".service-partner-add-partner-component").first();
        if (addPartnerComponent.length) {
            $('.linkPartner').addClass("linkWithPartner");
            $('.linkWithPartnerSpan').html(company);
        }
    }

    function showSuccessImage() {
        var successImage = $("<img/>").addClass("service-partner-success-image")
            .prop("src", "https://static.delti.com/static/common_files/images/sp-confirm-checkmark.png");
        $("body").append(successImage);
        setTimeout(function () {
            successImage.remove();
        }, 4600);
    }

    function submitAssembly(url) {
        var token = $("._csrf").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: url,
            type: 'POST',
            beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function () {
                $.ajax({
                    url: "/checkout/ng/step1",
                    type: 'GET',
                    success: function(data) {
                        $(".checkout-cart-view").replaceWith($('.checkout-cart-view', $(data)));
                        $("#checkoutOrderOverviewContainer").replaceWith($('#checkoutOrderOverviewContainer', $(data)));
                        $(".cart-view-checkout-container").replaceWith($('.cart-view-checkout-container', $(data)));
                    },
                    error: function(xhr, textStatus, errorThrown) {
                        console.error("Unable to update content: " + textStatus);
                    }
                });
            },
            error: function(xhr, textStatus, errorThrown) {
                console.error("Unable to submit assembly: " + textStatus);
            }
        });
    }

    function getSearchPayload() {
        var payload = {
            country: $("#service-partner-country").val(),
            cityOrZipCode: $("#service-partner-footer-city-or-zip-code-for-serp").val()
                                   || $("#service-partner-city-or-zip-code").val()
                                   || $("#service-partner-footer-city-or-zip-code-for-cart").val(),
            radius: $("#service-partner-radius").val(),
            ignoreCartProducts: $(".service-partner-ignore-cart-products").val()
        };

        var sort = $("#service-partner-sort");
        if (sort.length) {
            payload.sort = sort.val();
        }
        var initialSort = $("#service-partner-search-page-sort").val();
        if (!payload.sort && initialSort) {
            payload.sort = initialSort;
        }
        var fullyFittedFlow = $("#service-partner-search-page-fully-fitted-flow").val();
        if (fullyFittedFlow) {
            payload.fullyFittedFlow = fullyFittedFlow;
        }
        var rimSizeHint = $("#service-partner-search-page-rim-size-hint").val();
        if (rimSizeHint) {
            payload.rimSizeHint = rimSizeHint;
        }
        var spartnerFilters ="";
        $("input:checkbox[name=service-partner-filter-checkbox]:checked").each(function(){
           spartnerFilters = spartnerFilters.concat($(this).val() + ",");
        });
        spartnerFilters = spartnerFilters.substring(0, spartnerFilters.length - 1);
        payload.spartnerFilters = spartnerFilters;
        return payload;
    }

    function confirmServicePartner() {
        var confirmLink = $(this);
        var partnerId = confirmLink.data("partner-id");
        const params = new URLSearchParams(window.location.search);
        const redirectToReferrer = params.get("redirect");

        const payload = buildServicePartnerObject(partnerId);
        payload['redirect'] = redirectAfterSelectedServicePartner;
        const fullyFittedFlow = $("#service-partner-search-page-fully-fitted-flow").val();
        if (fullyFittedFlow) {
            payload['fullyFittedFlow'] = fullyFittedFlow;
        }

        showLoadingGif();

        $.ajax({
            url: "/service-partner/confirm/" + partnerId,
            type: "GET",
            cache: false,
            data: payload
        }).done(function (data) {
            var redirectTo = null;
            if (data && data.indexOf("redirectTo") !== -1) {
                redirectTo = JSON.parse(data).redirectTo;
            }
            var company = confirmLink.data("partner-company");
            saveSelectedServicePartnerDataToLocalStorage(partnerId);
            if (onConfirmServicePartner) {
                var street = confirmLink.data("partner-street");
                var city = confirmLink.data("partner-city");
                var phone = confirmLink.data("partner-phone");
                var servicePartnerInformation = {
                    company: company,
                    street: street,
                    city: city,
                    phone: phone
                };

                onConfirmServicePartner(servicePartnerInformation, partnerId);
            }

            updateServicePartnerAddComponentIfPresent(company);
            showSuccessImage();
            $.fancybox.close();

            if (fullyFittedFlow && redirectTo) {
                window.location.href = appendFullyFittedPartnerId(
                    redirectTo || $("#service-partner-search-page-pending-search-redirect").val() || "/search",
                    partnerId
                );
                return;
            }

            submitAssembly("/submit/assembly");
            if (redirectTo) {
                window.location.href = redirectTo;
                return;
            }

            if (redirectToReferrer != null && redirectToReferrer === "true") {
                window.location.href = document.referrer;
            }
        }).always(hideLoadingGif);
    }

    function appendFullyFittedPartnerId(redirectTo, partnerId) {
        if (!partnerId) {
            return redirectTo || "/search";
        }

        var target = redirectTo || "/search";
        var separator = target.indexOf("?") === -1 ? "?" : "&";
        return target + separator + "fullyFittedPartnerId=" + encodeURIComponent(partnerId);
    }

    function saveSelectedServicePartnerDataToLocalStorage(partnerId) {
        var servicePartnerData = buildServicePartnerObject(partnerId);
        var fullyFittedData = {
            partnerId: partnerId,
            fully_fitted_enabled: servicePartnerData.fully_fitted_enabled
        };
        localStorage.setItem('selectedServicePartnerData', JSON.stringify(fullyFittedData));
    }

    function initializeServicePartnerInformationPopupActions(searchPayload) {
        $(".service-partner-confirmation-button").on('click', confirmServicePartner);
        $(".service-partner-back-to-search-result-button").on('click', function () {
            if (openInPopup) {
                searchForServicePartners(searchPayload);
                return;
            }

            $.fancybox.close();
        });
    }

    function showServicePartnerDetails(partnerId, searchPayload, servicePartnerData) {
        showLoadingGif();

        $.ajax({
            url: "/service-partner/" + partnerId,
            type: "GET",
            data: servicePartnerData,
            cache: false
        }).done(function (data) {
            $.fancybox({
                width: 750,
                height: 600,
                content: data,
                fitToView: true,
                autoSize: false,
                afterClose: closePopup,
                helpers: {
                    overlay: {
                        locked: false
                    }
                }
            });
            initializeServicePartnerInformationPopupActions(searchPayload);
        }).always(hideLoadingGif);
    }

    function initializeSearchResultsFormActions(searchPayload) {
        function showFullyFittedRecoveryError($prompt, message) {
            if (!$prompt || !$prompt.length || !message) {
                return;
            }

            var $error = $prompt.find(".j-fully-fitted-recovery-error");
            if (!$error.length) {
                $error = $('<p class="spartnerErrorMessage j-fully-fitted-recovery-error"></p>');
                $prompt.prepend($error);
            }
            $error.text(message).show();
        }

        $("#service-partner-search-submit").on('click', function () {
            searchForServicePartners();
        });

        const cityOrZipCode = $(':input.for-local-storage[name="cityOrZipCode"]').val();
        if (typeof cityOrZipCode !== 'undefined') {
            localStorage.setItem('servicePartners:cityOrZipCode', cityOrZipCode);
        }

        $("#service-partner-city-or-zip-code").on('keypress', function (event) {
            if (event.which !== 13) {
                return;
            }

            event.preventDefault();
            searchForServicePartners();
        });

        $(".service-partner-details-link").add(".service-partner-action-link-details").on('click', function () {
            var partnerId = $(this).data("partner-id");
            const servicePartnerData = buildServicePartnerObject(partnerId);
            showServicePartnerDetails(partnerId, searchPayload, servicePartnerData);
        });
        $(".service-partner-action-link-confirm").on('click', confirmServicePartner);
        $(".j-spartner-filter").on('change', function () {
                searchForServicePartners();
            });

        $("#service-partner-radius-slider").slider({
            min: 5,
            max: 50,
            step: 5,
            value: $("#service-partner-radius").val(),
            slide: function (event, ui) {
                $("#service-partner-radius").val(ui.value);
            },
            stop: function () {
                searchForServicePartners();
            }
        });
        if (typeof hideSpFilters !== 'undefined' && hideSpFilters) {
            $(".service-partner-vehicle-type-filter-container").slice(1).hide();
        }

        $(".j-fully-fitted-increase-radius").on('click', function () {
            var $prompt = $(this).closest(".fully-fitted-no-results-prompt");
            $prompt.find(".j-fully-fitted-recovery-error").hide();
            var $radius = $("#service-partner-radius");
            if (!$radius.length) {
                return;
            }

            var currentRadius = parseInt($radius.val(), 10);
            var nextRadius = isNaN(currentRadius) ? 10 : Math.min(currentRadius + 5, 50);
            $radius.val(String(nextRadius));
            searchForServicePartners();
        });

        $(".j-fully-fitted-switch-mail-order").on('click', function () {
            var $prompt = $(this).closest(".fully-fitted-no-results-prompt");
            var intentionUrl = $("#service-partner-search-page-intention-url").val();
            var csrfToken = $("#service-partner-search-page-csrf-token").val();
            var csrfHeader = $("#service-partner-search-page-csrf-header").val() || "X-CSRF-TOKEN";
            var redirectTo = $("#service-partner-search-page-pending-search-redirect").val() || "/search";
            var switchErrorMessage = "Could not switch to mail order. Please try again.";

            if (!intentionUrl) {
                showFullyFittedRecoveryError($prompt, switchErrorMessage);
                return;
            }

            showLoadingGif();
            $.ajax({
                url: intentionUrl,
                type: "POST",
                data: { deliveryIntent: "MAIL_ORDER" },
                beforeSend: function (xhr) {
                    if (csrfToken) {
                        xhr.setRequestHeader(csrfHeader, csrfToken);
                    }
                    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                }
            }).done(function () {
                localStorage.removeItem("selectedServicePartnerData");
                $prompt.find(".j-fully-fitted-recovery-error").hide();
                window.location.href = redirectTo;
            }).fail(function () {
                showFullyFittedRecoveryError($prompt, switchErrorMessage);
            }).always(function () {
                hideLoadingGif();
            });
        });
    }

    function buildServicePartnerObject(partnerId) {
        let servicePartnerData = {};
        const fields = 
            ['id','price_tyre_washing','distance','distance_fetch_and_bring','mobile_premium',
            'price_rim_washing','price_disposal','business_hours_we','payperdelti','rim_washing',
            'carwash','latitude','delti_delivery_date','streetno','price_complete_tyre_washing',
            'longitude','mobile_radius','price_assembly_moto_to','price_assembly_moto_from','assembly_moto',
            'price_assembly_alloy','axle_alignment','tyres_return','price_assembly_truck','mobile','fax',
            'business_hours','country','moto_effective','price_axle_alignment','hourly_rate',
            'max_rim_diameter_moto','mediapartner','storage','price_disposal_moto','street','PMFP',
            'run_flat_tyres','tyre_assembly_moto','tyre_washing','price_disposal_truck',
            'price_fetch_and_bring','moto_rear_tyre','moto_front_tyre','zip','onsite_service_truck',
            'adac_discount','complete_tyre_washing','max_rim_diameter','change_complete_wheels',
            'equilibrate_moto','city','assembly_truck','wash_system','company','max_rim_diameter_truck',
            'fetch_and_bring','price_complete_wheels','price_storage','phone','PFP','delti_replacement_parts',
            'delti_oil','price_run_flat_tyres','price_assembly','local_rating','orders_delivered','rating',
            'email','bemerkung_ms','schedule_appointment_interface','schedule_appointment_interface_key','fully_fitted_enabled',
            'price_assembly_13','price_assembly_14','price_assembly_15','price_assembly_16',
            'price_assembly_17','price_assembly_18','price_assembly_19','price_assembly_20',
            'price_assembly_21','price_assembly_22','price_assembly_23','price_assembly_24',
            'price_assembly_25', "showFittingUpsellingOption", "showStorageUpsellingOption", "showDisposalUpsellingOption",
            "type", "tyresFittingUpsellingOption", "cwFittingUpsellingOption", "storageUpsellingOption", "disposalUpsellingOption", "price_disposal",
            "price_storag", "price_complete_wheels", "price_storage_item"];
        for(const field of fields) {

            let element = $(':input.service-partner-data-' + field + '[data-partner-id="' + partnerId + '"]');

            if (element.attr("type") === "checkbox") {
                servicePartnerData[field] = element.prop("checked") ? "true" : "false";
            } else {
                servicePartnerData[field] = element.val();
            }

        }
        return servicePartnerData;
    }

    function searchForServicePartners(payload) {
        var searchPayload;
        if (payload) {
            searchPayload = payload;
        } else {
            searchPayload = getSearchPayload();
        }

        var isOnCheckout = $("#service-partner-is-on-checkout").val();

        showLoadingGif();

        $.ajax({
            url: "/service-partner/search?isOnCheckout=" + isOnCheckout,
            type: "GET",
            cache: false,
            data: searchPayload
        }).done(function (data) {
            servicePartnerMap.clearServicePartners();

            if (searchResultsContainer) {
                searchResultsContainer.html(data);
            } else if (openInPopup) {
                $.fancybox({
                    width: 1050, height: 700,
                    content: data,
                    fitToView: true,
                    autoSize: false,
                    afterClose: closePopup,
                    helpers: {
                        overlay: {
                            locked: false
                        }
                    }
                });
            }

            if (typeof RedesignABTestingJS !== "undefined"
                    && RedesignABTestingJS.displayServicePartnerResult) {
                RedesignABTestingJS.displayServicePartnerResult();
            }
            servicePartnerMap.initialize();
            initializeSearchResultsFormActions(searchPayload);
        }).always(hideLoadingGif);
    }

    function searchForServicePartnersUsingSearchFormPayload() {
        var searchPayload = {
            country: $("#service-partner-search-form-country").val(),
            cityOrZipCode: $("#service-partner-search-form-city-or-zip-code").val(),
            radius: $("#service-partner-search-form-radius").val(),
            ignoreCartProducts: $(".service-partner-ignore-cart-products").val()
        };
        var initialSort = $("#service-partner-search-page-sort").val();
        if (initialSort) {
            searchPayload.sort = initialSort;
        }
        var fullyFittedFlow = $("#service-partner-search-page-fully-fitted-flow").val();
        if (fullyFittedFlow) {
            searchPayload.fullyFittedFlow = fullyFittedFlow;
        }
        var rimSizeHint = $("#service-partner-search-page-rim-size-hint").val();
        if (rimSizeHint) {
            searchPayload.rimSizeHint = rimSizeHint;
        }
        searchPayload.spartnerFilters = $("#service-partner-search-page-vehicle-type").val();
        searchForServicePartners(searchPayload);
    }

    function getHardcodedFilters() {
        if (typeof spHardcodedFilters !== 'undefined') {
            return spHardcodedFilters;
        }
        return "";
    }

    function getServiceIdsForUserEmail() {
        var invalidMailError = $(".service-partner-login-container #invalid-mail-error");
        invalidMailError.hide();
        $(".panel.panel-success").hide();
        $(".panel-danger#login-failed-error").hide();

        var userEmail = $(".login-service-form-row #user-email").val();

        if (!userEmail.length) {
            invalidMailError.show();
            return;
        }

        var loginSelectId = $("#service-partner-login-select-id");

        var loginLoader = $(".service-partner-login-container .service-partner-login-loader");
        loginLoader.removeClass("hiddenLoader");

        $.ajax({
            url: "/servicepartners/getpartnerids/" + encodeURI(userEmail),
            type: "GET"
        }).done(function (response) {
            loginLoader.addClass("hiddenLoader");
            if (!response.length) {
                invalidMailError.show();
                return;
            }
            response.forEach(function (id) {
                loginSelectId.append($('<option>', {
                    value: id,
                    text: id
                }))
            });
            loginSelectId.prop("disabled", false);
            $("#service-partner-login-id-input").prop("disabled", false);
            $("#service-partner-login-by-id-button").prop("disabled", false);
        }).fail(function () {
            loginLoader.addClass("hiddenLoader");
            invalidMailError.show();
        })
    }

    return {
        initializeSearchFormActions: function () {
            $("#service-partner-search-form-search-submit").on('click', function () {
                searchForServicePartnersUsingSearchFormPayload();
            });

            $("#service-partner-search-form-city-or-zip-code").on('keypress', function (event) {
                if (event.which !== 13) {
                    return;
                }

                event.preventDefault();
                searchForServicePartnersUsingSearchFormPayload();
            });
        },

        setSearchResultsContainer: function (container) {
            if (!container.length) {
                console.error("Could not set search results container");
                return;
            }

            searchResultsContainer = container;
        },

        openInPopup: function () {
            openInPopup = true;
        },

        onClosePopup: function (callback) {
            if (typeof callback !== "function") {
                console.error("Function type required");
                return;
            }

            onClosePopup = callback;
        },

        setPreselectedCityOrZipCode: function (value) {
            if (typeof value !== "boolean") {
                console.error("Boolean type required");
                return;
            }

            preselectedCityOrZipCode = value;
        },

        isPreselectedCityOrZipCode: function () {
            return preselectedCityOrZipCode;
        },

        setRedirectAfterSelectedServicePartner: function (value) {
            if (typeof value !== "boolean") {
                console.error("Boolean type required");
                return;
            }

            redirectAfterSelectedServicePartner = value;
        },

        onConfirmServicePartner: function (callback) {
            if (typeof callback !== "function") {
                console.error("Function type required");
                return;
            }

            onConfirmServicePartner = callback;
        },
        getHardcodedFilters: getHardcodedFilters,
        searchForServicePartners: searchForServicePartners,
        searchForServicePartnersUsingSearchFormPayload: searchForServicePartnersUsingSearchFormPayload,
        getServiceIdsForUserEmail: getServiceIdsForUserEmail,
        submitAssembly : submitAssembly
    };
})(ServicePartnerMap);

var ServicePartnerCheckout = (function (servicePartnerAddOn) {

    function isServicePartnerSelected() {
        var deliveryDetails = $(".j-service-delivery-details .j-service-company-name");
        if (deliveryDetails.length) {
            return deliveryDetails.first().html().trim();
        }
    }

    function setServicePartnerDetailsElementVisibility(deliveryMethodRadioButton) {
        var servicePartnerDetailsElement = $(".j-service-delivery-details").first();
        if (deliveryMethodRadioButton.prop("id") === "spartnersRadioButton") {
            servicePartnerDetailsElement.show();
        } else {
            servicePartnerDetailsElement.hide();
        }
    }

    function confirmServicePartner(servicePartnerInformation) {
        $('.j-service-company-name').first().html(servicePartnerInformation.company);
        $('.j-service-street-name').first().html(servicePartnerInformation.street);
        $('.j-service-city-name').first().html(servicePartnerInformation.city);
    }

    function getCityOrZipCode(checkIfServicePartnerSelected) {
        var zipCode = $("#invoiceAddress\\.postalCode").val();
        if (zipCode) {
            return zipCode;
        }

        var city = $("#invoiceAddress\\.town").val();
        if (city) {
            return city;
        }

        var cityOrZipCodeOnSerpPdp = $("#service-partner-footer-city-or-zip-code-for-serp").val();
        if (cityOrZipCodeOnSerpPdp) {
            return cityOrZipCodeOnSerpPdp;
        }

        var cityOrZipCodeInCart = $("#service-partner-footer-city-or-zip-code-for-cart").val();
        if (cityOrZipCodeInCart) {
            return cityOrZipCodeInCart;
        }

        if (checkIfServicePartnerSelected) {
            var preselectedDeliveryCity = $("#service-partner-delivery-address-city").text();
            if (preselectedDeliveryCity) {
                return preselectedDeliveryCity;
            }

            var preselectedDeliveryPostalCode = $("#service-partner-delivery-address-postalcode").text();
            if (preselectedDeliveryPostalCode) {
                return preselectedDeliveryPostalCode;
            }
        }

        return undefined;
    }

    function onClosePopup() {
        if (!isServicePartnerSelected()) {
            $(".j-service-delivery-details").hide();
            $("#spartnersRadioButton").prop("checked", false);
            var defaultDeliveryMethodElement = $("#defaultDeliveryMethod");
            if (defaultDeliveryMethodElement && defaultDeliveryMethodElement.val()) {
                $(".j-delivery-method-radio-buttons input[type='radio']")
                    .filter("[value='" + defaultDeliveryMethodElement.val() + "']")
                    .first()
                    .prop("checked", true).trigger("change");
                RedesignABTestingJS.addActiveSelection();
            }
        } else {
            $(".j-service-delivery-details").show();
            $("#spartnersRadioButton").prop("checked", true);
            RedesignABTestingJS.addActiveSelection();
            window.THEME.$document.trigger("deliveryChange", [$(this)]);
        }
    }

    function showNoCityOrZipCodeAlert() {
        $(".j-alert-ok-button").on('click', function () {
            $.fancybox.close();
        });

        $.fancybox({
            "content": $("#j-no-city-entered-alert-spartner"),
            afterClose: function () {
                $("#invoiceAddress\\.town").trigger("focus");
                onClosePopup();
            },
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    }

    function searchForServicePartners(checkIfServicePartnerSelected) {
        var cityOrZipCode = getCityOrZipCode(checkIfServicePartnerSelected);
        if (!cityOrZipCode) {
            showNoCityOrZipCodeAlert();
            return;
        }

        if (checkIfServicePartnerSelected && isServicePartnerSelected()) {
            window.THEME.$document.trigger("deliveryChange", [$(this)]);
            return;
        }

        var payload = {
            country: $("#service-partner-checkout-country").val(),
            cityOrZipCode: cityOrZipCode,
            radius: $("#service-partner-checkout-radius").val(),
            ignoreCartProducts: $(".service-partner-ignore-cart-products").val()
        };
        payload.spartnerFilters = servicePartnerAddOn.getHardcodedFilters();
        servicePartnerAddOn.searchForServicePartners(payload);
    }

    function initialize() {
        servicePartnerAddOn.setRedirectAfterSelectedServicePartner(false);
        servicePartnerAddOn.openInPopup();
        servicePartnerAddOn.onClosePopup(onClosePopup);
        servicePartnerAddOn.onConfirmServicePartner(confirmServicePartner);

        var deliveryMethodRadioButtons = ".j-delivery-method-radio-buttons input[type='radio']";
        var checkedDeliveryMethod = deliveryMethodRadioButtons + "[name=deliveryMethod]:checked";
        setServicePartnerDetailsElementVisibility($(checkedDeliveryMethod));
        $(deliveryMethodRadioButtons).on('click', function () {
            setServicePartnerDetailsElementVisibility($(this));
        });

        $("#spartnersRadioButton").on('click', function () {
            if(!toolTipClicked) {
                searchForServicePartners(true);
            } else {
                toolTipClicked = false;
            }
        });
        $(".j-change-service").first().on('click', function () {
            searchForServicePartners(false);
        });
    }

    function initializeForAddToCartPopup() {
        servicePartnerAddOn.setRedirectAfterSelectedServicePartner(true);
        servicePartnerAddOn.openInPopup();
        servicePartnerAddOn.onClosePopup(onClosePopup);
        servicePartnerAddOn.onConfirmServicePartner(confirmServicePartner);
    }

    return {
        initialize: initialize,
        initializeForAddToCartPopup: initializeForAddToCartPopup
    };
})(ServicePartnerAddOn);

var ServicePartnerInitializer = (function (servicePartnerAddOn, servicePartnerCheckout) {

    function searchForm() {
        var preselectedCityOrZipCodeInput = $("#service-partner-search-form-preselected-city-or-zip-code");
        if (!preselectedCityOrZipCodeInput.length) {
            return;
        }

        $("#service-partner-search-form-city-or-zip-code").val(preselectedCityOrZipCodeInput.val());
        servicePartnerAddOn.setPreselectedCityOrZipCode(false);
    }

    function footerSearchForm() {
        var preselectedCityOrZipCodeInput = $("#service-partner-footer-search-preselected-city-or-zip-code");
        if (!preselectedCityOrZipCodeInput.length) {
            return;
        }

        $("#service-partner-footer-city-or-zip-code").val(preselectedCityOrZipCodeInput.val());
    }

    function searchFormBox() {
        var servicePartnerSearchPageContainer = $(".service-partner-search-form-box-container").first();
        if (!servicePartnerSearchPageContainer.length) {
            return;
        }

        var preselectedCityOrZipCodeInput = $("#service-partner-search-form-box-preselected-city-or-zip-code");
        if (preselectedCityOrZipCodeInput.length) {
            $("#service-partner-search-form-box-city-or-zip-code").val(preselectedCityOrZipCodeInput.val());
        }

        servicePartnerAddOn.openInPopup();

        $("#service-partner-search-form-box-search-submit").on('click', function (event) {
            event.preventDefault();

            var searchPayload = {
                country: $("#service-partner-search-form-box-country").val(),
                cityOrZipCode: $("#service-partner-search-form-box-city-or-zip-code").val(),
                radius: $("#service-partner-search-form-box-radius").val(),
                ignoreCartProducts: $(".service-partner-ignore-cart-products").val()
            };
            searchPayload.spartnerFilters = servicePartnerAddOn.getHardcodedFilters();
            servicePartnerAddOn.searchForServicePartners(searchPayload);
        });
    }

    function searchPage() {
        var servicePartnerSearchPageContainer = $(".service-partner-search-page").first();
        var servicePartnerSearchFormContainer = $(".service-partner-search-form-container").first();
        if (!servicePartnerSearchPageContainer.length || !servicePartnerSearchFormContainer.length) {
            return;
        }

        servicePartnerAddOn.setRedirectAfterSelectedServicePartner(false);
        servicePartnerAddOn.setSearchResultsContainer(servicePartnerSearchFormContainer);
        servicePartnerAddOn.initializeSearchFormActions();

        var cityOrZipCode = $("#service-partner-search-page-city-or-zip-code").val();
        if (!cityOrZipCode) {
            if (servicePartnerAddOn.isPreselectedCityOrZipCode()) {
                servicePartnerAddOn.searchForServicePartnersUsingSearchFormPayload();
                return;
            }

            return;
        }

        var searchPayload = {
            country: $("#service-partner-search-page-country").val(),
            cityOrZipCode: cityOrZipCode,
            radius: $("#service-partner-search-page-radius").val(),
            ignoreCartProducts: $(".service-partner-ignore-cart-products").val(),
        };
        var initialSort = $("#service-partner-search-page-sort").val();
        if (initialSort) {
            searchPayload.sort = initialSort;
        }
        var fullyFittedFlow = $("#service-partner-search-page-fully-fitted-flow").val();
        if (fullyFittedFlow) {
            searchPayload.fullyFittedFlow = fullyFittedFlow;
        }
        var rimSizeHint = $("#service-partner-search-page-rim-size-hint").val();
        if (rimSizeHint) {
            searchPayload.rimSizeHint = rimSizeHint;
        }
        searchPayload.spartnerFilters = $("#service-partner-search-page-vehicle-type").val();
        servicePartnerAddOn.searchForServicePartners(searchPayload);
    }

    function checkout() {
        var servicePartnerCheckoutDetailsContainer = $(".service-partner-checkout-details-container").first();
        var servicePartnerCheckoutPopupContainer = $(".service-partner-checkout-popup-container").first();
        if (!servicePartnerCheckoutDetailsContainer.length || !servicePartnerCheckoutPopupContainer.length) {
            return;
        }

        var servicePartnerRadioButton = $("#spartnersRadioButton");
        if (servicePartnerRadioButton.length) {
            // initialize service partner when present on checkout step 1
            servicePartnerCheckoutDetailsContainer.hide();
            servicePartnerCheckout.initialize();
            return;
        }

        // initialize service partner when present on checkout step 2
        servicePartnerCheckoutPopupContainer.hide();

        servicePartnerAddOn.setRedirectAfterSelectedServicePartner(false);
        servicePartnerAddOn.setSearchResultsContainer(servicePartnerCheckoutDetailsContainer);
        servicePartnerAddOn.onConfirmServicePartner(function () {
            $("#checkoutForm").trigger('submit');
        });

        var zipCode = $("#billing-address-zip-code").val();
        var city = $("#billing-address-city").val();
        var cityOrZipCode;
        if (zipCode) {
            cityOrZipCode = zipCode;
        } else {
            cityOrZipCode = city;
        }

        var searchPayload = {
            country: $("#service-partner-checkout-country").val(),
            cityOrZipCode: cityOrZipCode,
            radius: $("#service-partner-checkout-radius").val(),
            ignoreCartProducts: $(".service-partner-ignore-cart-products").val()
        };
        searchPayload.spartnerFilters = servicePartnerAddOn.getHardcodedFilters();
        servicePartnerAddOn.searchForServicePartners(searchPayload);
    }

    function servicePartnerSessionDeliveryMethod() {
        var servicePartnerSessionDeliveryMethodRadio = $("#service-partner-session-delivery-radio-button");
        if (!servicePartnerSessionDeliveryMethodRadio.length) {
            return;
        }

        var servicePartnersRadioButton = $("#spartnersRadioButton");
        if (servicePartnersRadioButton.is(":checked")) {
            servicePartnersRadioButton.prop("checked", false);
            servicePartnerSessionDeliveryMethodRadio.prop("checked", true);
        }
    }

    function productDetailPage() {
        var servicePartnerContentTab = $(".service-partner-content-tab").first();
        var enabledServicePartnerCheckbox = $("#service-partner-pdp-enabled-service-partner");
        var enabledServicePartnerTabCheckbox = $("#service-partner-pdp-enabled-service-partner-tab");
        if (!servicePartnerContentTab.length || !enabledServicePartnerCheckbox.length
            || !enabledServicePartnerTabCheckbox.length || !enabledServicePartnerCheckbox.is(":checked")
            || !enabledServicePartnerTabCheckbox.is(":checked")) {
            return;
        }

        servicePartnerAddOn.setRedirectAfterSelectedServicePartner(false);
        servicePartnerAddOn.setSearchResultsContainer(servicePartnerContentTab);
        if (servicePartnerAddOn.isPreselectedCityOrZipCode()) {
            var searchPayload = {
                country: $("#service-partner-search-form-country").val(),
                cityOrZipCode: $("#service-partner-search-form-city-or-zip-code").val(),
                radius: $("#service-partner-search-form-radius").val(),
                ignoreCartProducts: $(".service-partner-ignore-cart-products").val(),
            };
            searchPayload.spartnerFilters = servicePartnerAddOn.getHardcodedFilters();
            servicePartnerAddOn.searchForServicePartners(searchPayload);
            return;
        }

        servicePartnerAddOn.initializeSearchFormActions();
    }

    function areaList() {
        var servicePartnerAreaListContainer = $(".service-partner-area-list-container").first();
        if (!servicePartnerAreaListContainer.length) {
            return;
        }

        $(".service-partner-area-list-search-submit").on('click', function () {
            var searchPayload = {
                country: $("#service-partner-area-list-country").val(),
                cityOrZipCode: $("#service-partner-area-list-city-or-zip-code").val(),
                radius: $("#service-partner-area-list-radius").val(),
                ignoreCartProducts: $(".service-partner-ignore-cart-products").val(),
            };
            searchPayload.spartnerFilters = servicePartnerAddOn.getHardcodedFilters();
            servicePartnerAddOn.searchForServicePartners(searchPayload);
        });
    }

    function login() {
        var servicePartnerLoginForm = $(".form-service-partners-login").first();
        if (!servicePartnerLoginForm.length) {
            return;
        }

        $("#service-partner-login-get-ids").on("click", function () {
            ServicePartnerAddOn.getServiceIdsForUserEmail();

        })
    }

    function checkAssemblyStep1() {
        if (window.location.pathname === '/checkout/ng/step1') {
            function checkSelectedDeliveryMethod() {
                setTimeout(function() {
                    const selectedValue = $('input[name="deliveryMethod"]:checked').val();
                    if (selectedValue === 'spartners') {
                        ServicePartnerAddOn.submitAssembly("/submit/assembly");
                    } else {
                        ServicePartnerAddOn.submitAssembly("/remove/assembly");
                    }
                }, 100);
            }

            checkSelectedDeliveryMethod();

            $('input[name="deliveryMethod"]').on('change', function() {
                checkSelectedDeliveryMethod();
            });
        }
    }

    function checkAssemblyStep2() {
        if (window.location.pathname === '/checkout/ng/step2') {
            var checkoutDeliveryMethod = $('input[name="checkoutDeliveryMethod"]').val();
            if (checkoutDeliveryMethod === "spartners") {
                ServicePartnerAddOn.submitAssembly("/submit/assembly");
            }
        }
    }

    function init() {
        searchForm();
        footerSearchForm();
        searchFormBox();
        searchPage();
        checkout();
        servicePartnerSessionDeliveryMethod();
        productDetailPage();
        areaList();
        login();
        checkAssemblyStep1();
        checkAssemblyStep2();
    }

    return {
        init: init
    };
})(ServicePartnerAddOn, ServicePartnerCheckout);

$(document).ready(function() {
    ServicePartnerInitializer.init();
    $(document).on("click", "#service-partner-footer-search-submit-for-serp", function() {
        ServicePartnerCheckout.initializeForAddToCartPopup();
        ServicePartnerAddOn.searchForServicePartners();
    });

    $(document).on("click", "#service-partner-footer-search-submit-for-cart", function() {
        ServicePartnerCheckout.initializeForAddToCartPopup();
        ServicePartnerAddOn.searchForServicePartners();
    });
});